import { request, parseMessage } from '../../../utilities';

const executePayment = async context => {
  logger.info(`[@fingermarkglobal/marshal][executePayment]: context [${JSON.stringify(context)}]`);

  const { buffer = '', config = {} } = context || {};

  try {
    const response = await request({ buffer, config });

    const fields = parseMessage(response);

    logger.info(
      `[@fingermarkglobal/marshal][executePayment]: parsed message fields [${JSON.stringify(
        fields,
      )}]`,
    );

    const { responseCode = '', responseMessage = '' } = fields || {};

    if (responseCode !== '000' && responseCode !== '00') {
      throw new Error(responseMessage);
    }

    return { fields };
  } catch (err) {
    logger.error('[@fingermarkglobal/marshal] Error in executePayment:', err);
    throw err;
  }
};

export { executePayment };
